import { render, staticRenderFns } from "./MHButton.vue?vue&type=template&id=40cb0d9b&scoped=true&"
import script from "./MHButton.vue?vue&type=script&lang=ts&"
export * from "./MHButton.vue?vue&type=script&lang=ts&"
import style0 from "./MHButton.vue?vue&type=style&index=0&id=40cb0d9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cb0d9b",
  null
  
)

export default component.exports